import { render, staticRenderFns } from "./APIDocumentation.vue?vue&type=template&id=362246fa&"
import script from "./APIDocumentation.vue?vue&type=script&lang=js&"
export * from "./APIDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./APIDocumentation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('362246fa')) {
      api.createRecord('362246fa', component.options)
    } else {
      api.reload('362246fa', component.options)
    }
    module.hot.accept("./APIDocumentation.vue?vue&type=template&id=362246fa&", function () {
      api.rerender('362246fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/APIDocumentation.vue"
export default component.exports